import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-food-category-list',
  templateUrl: './food-category-list.component.html',
  styleUrls: ['./food-category-list.component.scss'],
})
export class FoodCategoryListComponent {

  constructor() { }

}
